import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";

export default function Privacidad() {
  return (
    <div className="min-h-screen font-body">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs font-mono text-muted-foreground hover:text-neon-cyan uppercase tracking-widest mb-8"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Volver al sitio
        </Link>

        <header className="mb-10 pb-8 border-b border-white/10">
          <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-[0.3em] text-neon-cyan mb-3">
            <Shield className="w-3.5 h-3.5" />
            DOCUMENTO LEGAL
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter leading-tight mb-3">
            Aviso de Privacidad
          </h1>
          <p className="text-muted-foreground text-sm">
            Conforme a la Ley Federal de Protección de Datos Personales en Posesión de los
            Particulares (LFPDPPP) — México
          </p>
        </header>

        <section className="space-y-8 text-white/85 leading-relaxed">
          <div>
            <div className="text-[11px] font-mono uppercase tracking-widest text-neon-cyan mb-2">
              RESPONSABLE DEL TRATAMIENTO
            </div>
            <p>
              <strong>C. RICARDO ZERMEÑO MEJÍA</strong>, en su carácter de apoderado legal de{" "}
              <strong>Marketing de Inteligencia Artificial S. de R.L. de C.V.</strong>, con
              domicilio en Av. Américas 1545, pisos 20, 21, 22 y 23, Colonia Providencia,
              Guadalajara, Jalisco, México, es el responsable del uso, protección y tratamiento
              de sus datos personales.
            </p>
          </div>

          <Section number="1" title="Datos personales que recabamos">
            <ul className="list-disc pl-6 space-y-1.5">
              <li>Nombre y/o alias (handle de red social).</li>
              <li>Número de teléfono celular.</li>
              <li>Correo electrónico.</li>
              <li>Enlace público a red social (Instagram, TikTok, X, YouTube, Facebook, Twitch, Linktree u otras).</li>
              <li>Datos de cobro: correo PayPal o CLABE / cuenta bancaria (almacenados de forma cifrada mediante Fernet).</li>
              <li>Dirección IP y user-agent (con fines de anti-fraude y validación de clics únicos).</li>
              <li>Historial de pujas, montos pagados y clics generados.</li>
            </ul>
          </Section>

          <Section number="2" title="Finalidades primarias del tratamiento">
            <ul className="list-disc pl-6 space-y-1.5">
              <li>Identificar al usuario y permitirle acceso a la plataforma.</li>
              <li>Procesar pagos, pujas y transferencias de premios.</li>
              <li>Validar clics únicos y prevenir fraude o abuso automatizado.</li>
              <li>Cumplir con obligaciones fiscales, contables y regulatorias.</li>
              <li>Contactar al usuario por WhatsApp o correo para notificar premios o avisos importantes.</li>
            </ul>
          </Section>

          <Section number="3" title="Finalidades secundarias (opcionales)">
            <p>
              Envío de comunicaciones promocionales, encuestas y nuevas mecánicas. El usuario
              puede negarse a estas finalidades enviando la palabra "BAJA" al WhatsApp
              +52 33 4280 2102 sin que ello afecte el servicio principal.
            </p>
          </Section>

          <Section number="4" title="Transferencias de datos">
            Sus datos podrán ser compartidos únicamente con: (i) el procesador de pagos Stripe
            para ejecutar la transacción, (ii) el proveedor de infraestructura en la nube para
            hospedar los servicios, y (iii) las autoridades competentes cuando exista un
            requerimiento formal fundado y motivado. No comercializamos ni cedemos sus datos
            a terceros con fines publicitarios.
          </Section>

          <Section number="5" title="Derechos ARCO">
            En cualquier momento usted puede ejercer sus derechos de Acceso, Rectificación,
            Cancelación u Oposición respecto al uso de sus datos personales, enviando su solicitud
            al WhatsApp +52 33 4280 2102 o al domicilio arriba señalado, incluyendo copia de una
            identificación oficial y la descripción clara del derecho que desea ejercer. La
            respuesta se emitirá en un plazo máximo de 20 días hábiles.
          </Section>

          <Section number="6" title="Medidas de seguridad">
            La información sensible (payout wallet) se almacena cifrada con Fernet
            (AES-128 en modo CBC + HMAC-SHA256). Las contraseñas se guardan como hash bcrypt.
            Todas las comunicaciones se realizan sobre HTTPS/TLS 1.2 o superior. Ningún empleado
            tiene acceso directo a las claves de cifrado.
          </Section>

          <Section number="7" title="Cookies y tecnologías similares">
            Utilizamos cookies estrictamente necesarias para mantener la sesión iniciada y el
            almacenamiento local (localStorage) para preferencias del usuario. No usamos cookies
            publicitarias de terceros.
          </Section>

          <Section number="8" title="Menores de edad">
            La plataforma está dirigida únicamente a personas mayores de 18 años. En caso de
            detectar registros de menores, la cuenta será cancelada inmediatamente y los fondos
            devueltos al método de pago original menos la comisión bancaria aplicable.
          </Section>

          <Section number="9" title="Modificaciones al Aviso de Privacidad">
            El presente aviso podrá ser modificado en cualquier momento; las actualizaciones se
            publicarán en esta misma URL con fecha visible. El uso continuo del servicio
            constituye aceptación tácita de los cambios.
          </Section>

          <div className="mt-12 pt-8 border-t border-white/10">
            <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground mb-3">
              RESPONSABLE
            </div>
            <p className="font-heading font-bold text-lg">C. RICARDO ZERMEÑO MEJÍA</p>
            <p className="text-sm text-muted-foreground mt-1">
              Marketing de Inteligencia Artificial S. de R.L. de C.V.
            </p>
            <p className="text-sm text-muted-foreground">
              Av. Américas 1545, pisos 20-23, Providencia, Guadalajara, Jalisco, México
            </p>
            <p className="text-sm text-muted-foreground">WhatsApp: +52 33 4280 2102</p>
            <p className="text-[11px] font-mono text-muted-foreground mt-4 uppercase tracking-widest">
              Última actualización: {new Date().toLocaleDateString("es-MX", { year: "numeric", month: "long", day: "numeric" })}
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

function Section({ number, title, children }) {
  return (
    <div data-testid={`section-${number}`}>
      <div className="flex items-baseline gap-3 mb-2">
        <span className="font-mono text-neon-cyan text-sm">{number}.</span>
        <h3 className="font-heading font-bold text-lg leading-tight">{title}</h3>
      </div>
      <div className="pl-6">{children}</div>
    </div>
  );
}
